import React, { Component } from 'react';
import Popover from 'material-ui/Popover';

import moment from 'moment';

// Disable `no-unused-vars` here - moment just needs the module to be loaded
// eslint-disable-next-line no-unused-vars
import tz from 'moment-timezone';

import ClockIcon from 'material-ui/svg-icons/device/access-time';

import theme from '../../../muiTheme';

const styles = {
  dateTimeContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  clockIcon: {
    color: theme.palette.primary1Color,
    margin: '0 4px',
    height: '18px',
    width: '18px',
    cursor: 'pointer'
  },
  popoverDl: {
    fontSize: '0.833em',
    margin: '0.66em'
  },
  timezoneName: {
    fontWeight: 'bold',
    paddingRight: '4px'
  }
};

class DateTimeWithPopover extends Component {
  state = {
    open: false
  };

  timezones = {
    Alaska: 'America/Anchorage',
    Pacific: 'America/Los_Angeles',
    Mountain: 'America/Denver',
    Central: 'America/Chicago',
    Eastern: 'America/New_York'
  };

  handleClick = e => {
    e.preventDefault();

    this.setState({
      open: true,
      anchorEl: e.currentTarget
    });
  };

  handleRequestClose = () => {
    this.setState({
      open: false
    });
  };

  renderPopoverText(datetime, format) {
    const convertToTimezone = timezone =>
      moment(datetime)
        .tz(timezone)
        .format(format);

    return (
      <table style={styles.popoverDl}>
        <tbody>
          {Object.keys(this.timezones).map(timezone => (
            <tr key={timezone}>
              <td style={styles.timezoneName}>{timezone}</td>
              <td>{convertToTimezone(this.timezones[timezone])}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  render() {
    const { open, anchorEl } = this.state;
    const { datetime, format } = this.props;

    const localDateTime = moment(datetime).format(format);

    return (
      <div style={styles.dateTimeContainer}>
        <span title={localDateTime}>{localDateTime}</span>
        <ClockIcon style={styles.clockIcon} onClick={this.handleClick} />
        <Popover
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{
            horizontal: 'right',
            vertical: 'center'
          }}
          targetOrigin={{
            horizontal: 'left',
            vertical: 'bottom'
          }}
          onRequestClose={this.handleRequestClose}
        >
          {this.renderPopoverText(datetime, format)}
        </Popover>
      </div>
    );
  }
}

export default DateTimeWithPopover;



// WEBPACK FOOTER //
// ./src/components/common/DateTimeWithPopover/DateTimeWithPopover.js